import styled from "styled-components";

export default styled.span`
  font-size: 13px;
  line-height: 16px;
`;
